import { ThemeColors } from "./theme.base";

export const devColors = {
  light: {
    primary: { main: "#6554C0", light: "#8B7FD6", dark: "#4B3D9E" },
    secondary: { main: "#4E9DA8" },
    background: {
      default: "#F6F5FB",
      paper: "#FFFFFF",
      custom: "#EFEDF8",
      body: "#F6F5FB",
    },
    text: { primary: "#1F2937", secondary: "#4B5563" },
    link: "#2563EB",
    highlightedRow: "#ECE9FB",
    borders: { appBar: "2px solid #8B7FD6" },
    dataGrid: { header: "#EFEDF8" },
  },

  dark: {
    primary: { main: "#A89BE0", light: "#C7BEF0", dark: "#7E6FCB" },
    secondary: { main: "#7FBFC9" },
    background: {
      default: "#14121D",
      paper: "#1A1726",
      custom: "#241F35",
      body: "#14121D",
    },
    text: { primary: "#E8E6F0", secondary: "#A7A2BA" },
    link: "#60A5FA",
    highlightedRow: "#2E2A55",
    borders: { appBar: "2px solid #7E6FCB" },
    dataGrid: { header: "#241F35" },
  },
} satisfies Record<"light" | "dark", ThemeColors>;
